module.exports = __webpack_public_path__ + "media/images/category/dummy/hat04-27b8c42d3d837532d0c9b1425ab068e1.jpg";